
/* injects from baggage-loader */

export const getSwarmPartnerStreamsRequest = () => ({
    source: 'notifications',
    what: { partner_streams: ['channels'] },
});